var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppUploadfiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9997 0C39.8097 0 40.5598 0.329847 41.1295 0.870411L59.1088 18.8497C59.6791 19.4202 59.9998 20.1936 59.9998 21V66C59.9998 69.3002 57.2997 72 53.9997 72H6.00005C2.70002 72 0 69.3002 0 66V6.00005C0 2.7008 2.70002 0 6.00005 0H38.9997ZM5.99979 66.0001H53.9995L53.9996 24H38.9996C37.3498 24 35.9997 22.6495 35.9997 21.0002V6.00018H5.99979V66.0001ZM27.8697 33.9303C29.0396 32.7601 30.9599 32.7601 32.1297 33.9303L38.0695 39.9304C39.9596 41.8199 38.6093 45.0603 35.9392 45.0603H32.9394V54.029C32.9394 55.709 31.5894 57.0288 29.9395 57.0288C28.2897 57.0288 26.9396 55.7093 26.9396 54.029V45.0603H23.9398C21.2697 45.0603 19.9197 41.8202 21.8097 39.9304L27.8697 33.9303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppUploadfiles);
export default __webpack_public_path__ + "static/media/app_uploadfiles.1852df30b063b870bf452ba57f985e92.svg";
export { ForwardRef as ReactComponent };